import { render, staticRenderFns } from "./NewPaymentsTableAdmin.vue?vue&type=template&id=619406fe&scoped=true"
import script from "./NewPaymentsTableAdmin.vue?vue&type=script&lang=js"
export * from "./NewPaymentsTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619406fe",
  null
  
)

export default component.exports